export enum VendorTab {
  Information = 'information',
  Contacts = 'contacts',
  Tasks = 'tasks',
  Tickets = 'tickets',
  Contracts = 'contracts',
  RelatedAudits = 'relatedAudits',
}

export type VendorsRouteParams = {
  tab?: VendorTab;
  contactId?: string;
  vendorId: string;
  organizationId?: string;
  ticketId?: string;
  taskId?: string;
};
